export const FTN_UPDATE_PERMISSION = 4;
export const FTN_DELETE_PERMISSION = 5;
export const FTN_ADD_PERMISSION = 9;

export const FTN_ADD_FOLDER = 6;
export const FTN_DELETE_FOLDER = 7;
export const FTN_UPDATE_FOLDER = 8;